module.exports = __webpack_public_path__ + "img/key.2ea5fce5.svg";